export default function ErrorScreen({ message = "Something unexpected happened." }) {
  return (
    <div className="grid min-h-[50vh] place-items-center p-8 text-center">
      <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <h2 className="mb-2 text-2xl font-semibold text-slate-900">Uh-oh. Something went wrong.</h2>
        <p className="text-sm text-slate-600">{message} Please try again later.</p>
        <div className="mt-4 flex justify-center gap-2">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded-xl bg-sky-600 px-4 py-2 text-sm font-semibold text-white hover:bg-sky-700"
          >
            Reload
          </button>
          <button
            type="button"
            onClick={() => window.history.back()}
            className="rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
